module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"currentPass":"Current password","newPass":"New password","confirmPass":"Confirm password","changePass":"Change password","passChanged":"Password was changed"}}')
  delete Component.options._Ctor
}
